import { appEventTypes } from "@src/common/events/AppEventTarget";
import { INotification } from "@src/modules/App/Notifications/shared/types";

class AnalysisCompletedEvent extends CustomEvent<null> {
  constructor(public notification: INotification) {
    super(appEventTypes.STUDY_ANALYSIS_COMPLETED);
  }
}

export default AnalysisCompletedEvent;
